import HeroSection    from './home/HeroSection';
import StatsBar       from './home/StatsBar';
import FeaturesSection from './home/FeaturesSection';
import UAESection     from './home/UAESection';
import ScreensMarquee from './home/ScreensMarquee';
import HowItWorks     from './home/HowItWorks';
import QuoteSection   from './home/QuoteSection';
import ForWhoSection  from './home/ForWhoSection';
import CTASection     from './home/CTASection';
import Ticker         from '../components/Ticker';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <Ticker />
      <StatsBar />
      <FeaturesSection />
      <UAESection />
      <ScreensMarquee />
      <HowItWorks />
      <QuoteSection />
      <ForWhoSection />
      <CTASection />
    </>
  );
}
